<template>
  <div class="container home-wrap">
      <h1>{{$ml.with('VueJS').get('HomeTitle')}}</h1>
  </div>
</template>


<script>
  export default {
    name: 'home',
    components: {
    },
    data: () => ({
    }),
    methods: {

    },
    mounted() {
      if (!this.$store.state.isAuthenticated()) {
        this.$router.push({path: '/login'})
      }
    }
  }
</script>